(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("b7OGL", function(module, exports) {

$parcel$export(module.exports, "pageParams", function () { return $8197aae7a6f6ea45$export$e1acdbbe7c24d88; });
$parcel$export(module.exports, "validationVariants", function () { return $8197aae7a6f6ea45$export$1321ab7f525f446c; });
$parcel$export(module.exports, "assertPageParams", function () { return $8197aae7a6f6ea45$export$ca425444c95bb4f5; });
$parcel$export(module.exports, "fetchData", function () { return $8197aae7a6f6ea45$export$8134c072fddab6a5; });

var $2oIdW = parcelRequire("2oIdW");

var $6N6HZ = parcelRequire("6N6HZ");

var $dlQyz = parcelRequire("dlQyz");
const $8197aae7a6f6ea45$var$MAX_NUMBER_OF_PHOTOS = 3000;
const $8197aae7a6f6ea45$export$e1acdbbe7c24d88 = {
    resetData: ()=>localStorage.clear(),
    eventName: ()=>localStorage.getItem("eventName"),
    saveEventName: (eventName)=>localStorage.setItem("eventName", eventName),
    homeLink: ()=>localStorage.getItem("locWA"),
    saveHomeLink: (homeLink)=>localStorage.setItem("locWA", homeLink),
    attendeeUid: ()=>localStorage.getItem("attUidWA"),
    saveAttendeeUid: (attendeeUid)=>localStorage.setItem("attUidWA", attendeeUid),
    generatedAttId: ()=>localStorage.getItem("generatedAttId"),
    saveGeneratedAttId: (generatedAttId)=>localStorage.setItem("generatedAttId", generatedAttId)
};
/**
 * @typedef {Object} ValidationVariant
 */ /**
 * Make a validation variant
 *
 * @param isValid {Function}
 * @param message {String}
 * @returns {ValidationVariant}
 */ function $8197aae7a6f6ea45$var$makeValidationVariant(isValid, message) {
    return {
        isValid: isValid,
        message: message
    };
}
const $8197aae7a6f6ea45$export$1321ab7f525f446c = {
    isAssignedAttendeeUid: $8197aae7a6f6ea45$var$makeValidationVariant(()=>$8197aae7a6f6ea45$export$e1acdbbe7c24d88.attendeeUid() !== null, "AttendeeUid is not assigned in local storage"),
    isSetUpEventName: $8197aae7a6f6ea45$var$makeValidationVariant(()=>Boolean($8197aae7a6f6ea45$export$e1acdbbe7c24d88.eventName()), "Invalid event code. Please contact support")
};
function $8197aae7a6f6ea45$export$ca425444c95bb4f5(validationList) {
    const error = getError();
    if (error) {
        // NOTE: Show error until fixed
        alert(error.message);
        window.location.reload();
    }
    function getError() {
        return validationList.find((validation)=>!validation.isValid());
    }
}
const $8197aae7a6f6ea45$export$8134c072fddab6a5 = {
    event: async (eventName = $8197aae7a6f6ea45$export$e1acdbbe7c24d88.eventName())=>{
        const { result: result } = await (0, $2oIdW.findEvent)({
            eventName: eventName,
            basicDataOnly: true
        });
        if (!result) {
            alert((0, $6N6HZ.default).eventNotExist(eventName));
            window.location.reload();
        }
        return result;
    },
    photos: async (eventId, attUid = $8197aae7a6f6ea45$export$e1acdbbe7c24d88.attendeeUid())=>new Promise((resolve, reject)=>{
            (0, $dlQyz.occoApi).photoListRetrieve("attendee_uid", attUid, eventId, null, null, null, $8197aae7a6f6ea45$var$MAX_NUMBER_OF_PHOTOS, null, null, null, false, null, null, null, null, null, attUid, true, null, null, (err, result)=>{
                if (err) reject(err);
                else resolve(result);
            });
        })
};

});
parcelRegister("6N6HZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f1c85de2ff4481d$export$2e2bcd8739ae039; });
var $4f1c85de2ff4481d$export$2e2bcd8739ae039 = {
    eventNotExist: (eName)=>`This "${eName}" event name (eName) doesn't exist. Please use right event name`
};

});


parcelRegister("htyRP", function(module, exports) {

$parcel$export(module.exports, "setLogo", function () { return $cb903105c61ec330$export$760bdf29584b90d6; });
$parcel$export(module.exports, "setBackground", function () { return $cb903105c61ec330$export$2e65e79124cca55d; });

var $hUmXJ = parcelRequire("hUmXJ");
const $cb903105c61ec330$export$760bdf29584b90d6 = (src)=>(0, $hUmXJ.initSetLogo)(".reg-logo__img", "reg-logo__img_hidden", src);
function $cb903105c61ec330$export$2e65e79124cca55d(src) {
    const body = document.querySelector(".body");
    if (src) body.style.backgroundImage = `url(${src})`;
    else body.classList.add("body_background_second");
}

});

parcelRegister("jGoKE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d5bc08737667bab$export$2e2bcd8739ae039; });

var $fVs1R = parcelRequire("fVs1R");

var $cHDqb = parcelRequire("cHDqb");
var $2d5bc08737667bab$export$2e2bcd8739ae039 = (0, $cHDqb.init)((0, $fVs1R.default).init());

});
parcelRegister("fVs1R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c04735565db7e8ae$export$2e2bcd8739ae039; });

var $4ZXvf = parcelRequire("4ZXvf");
class $c04735565db7e8ae$export$2e2bcd8739ae039 {
    static init() {
        return new $c04735565db7e8ae$export$2e2bcd8739ae039();
    }
    getCurrentIndex() {
        return Number(localStorage.getItem(this.INDEX_KEY));
    }
    setCurrentIndex(index) {
        localStorage.setItem(this.INDEX_KEY, String(index));
    }
    getList() {
        const parsedJSON = JSON.parse(localStorage.getItem(this.LIST_KEY));
        return parsedJSON.map((0, $4ZXvf.makeAccount));
    }
    setList(list) {
        localStorage.setItem(this.LIST_KEY, JSON.stringify(list));
    }
    constructor(){
        this.LIST_KEY = "accountsList";
        this.INDEX_KEY = "accountsCurrentIndex";
        if (!localStorage.getItem(this.LIST_KEY)) localStorage.setItem(this.LIST_KEY, JSON.stringify([]));
        if (!localStorage.getItem(this.INDEX_KEY)) localStorage.setItem(this.INDEX_KEY, "-1");
    }
}

});
parcelRegister("4ZXvf", function(module, exports) {

$parcel$export(module.exports, "makeAccount", function () { return $6f661c2570735436$export$11be4f79df749898; });
$parcel$export(module.exports, "calculateExpiredDate", function () { return $6f661c2570735436$export$6c5f1943c09e93a1; });

var $emJrH = parcelRequire("emJrH");
const $6f661c2570735436$export$11be4f79df749898 = ({ attendeeUid: attendeeUid, eventCode: eventCode, eventLogo: eventLogo = "", name: name = "", email: email = "", phoneNumber: phoneNumber = "", regDate: regDate, expiredDate: expiredDate = null })=>({
        attendeeUid: attendeeUid,
        eventCode: eventCode,
        eventLogo: eventLogo,
        name: name,
        email: email,
        phoneNumber: phoneNumber,
        regDate: new Date(regDate),
        expiredDate: expiredDate ? new Date(expiredDate) : null
    });
const $6f661c2570735436$export$6c5f1943c09e93a1 = (event, attendee)=>event.photo_auto_delete_days ? (0, $emJrH.addDays)(attendee.created_date, event.photo_auto_delete_days) : null;

});
parcelRegister("emJrH", function(module, exports) {

$parcel$export(module.exports, "addDays", function () { return $95dbb494488a4985$export$dd412b56f1e4d8aa; });
$parcel$export(module.exports, "formatDate", function () { return $95dbb494488a4985$export$3ae94a2503e890a1; });
function $95dbb494488a4985$export$dd412b56f1e4d8aa(targetDate, days) {
    const date = new Date(targetDate);
    date.setDate(date.getDate() + days);
    return date;
}
function $95dbb494488a4985$export$3ae94a2503e890a1(date, userLocale = navigator.language) {
    const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    };
    return new Intl.DateTimeFormat(userLocale, options).format(date);
}

});



parcelRegister("cHDqb", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $bebcbb1394aaf976$export$2cd8252107eb640b; });

var $4ZXvf = parcelRequire("4ZXvf");
function $bebcbb1394aaf976$export$2cd8252107eb640b(storage) {
    const subscriptionsOnChangeCurrentIndex = [];
    return {
        addAccount: addAccount,
        updateAccount: updateAccount,
        isExistsAccount: isExistsAccount,
        findIndex: findIndex,
        findIndexByEventCode: findIndexByEventCode,
        getList: getList,
        setCurrentAccount: setCurrentAccount,
        getCurrentAccount: getCurrentAccount,
        getCurrentIndex: getCurrentIndex,
        onChangeCurrentIndex: onChangeCurrentIndex,
        setList: setList
    };
    function addAccount(params) {
        const account = (0, $4ZXvf.makeAccount)(params);
        storage.setList([
            account,
            ...getList()
        ]);
    }
    function updateAccount(account) {
        const list = [
            ...getList()
        ];
        const index = list.findIndex((acc)=>acc.attendeeUid === account.attendeeUid && acc.eventCode === account.eventCode);
        if (index > -1) {
            const currentAccount = list[index];
            const updatedAccount = {
                ...currentAccount,
                ...account
            };
            list[index] = updatedAccount;
            storage.setList(list);
        }
    }
    function getCurrentAccount() {
        return getList()[storage.getCurrentIndex()] || null;
    }
    function getCurrentIndex() {
        return storage.getCurrentIndex();
    }
    function setCurrentAccount(index) {
        storage.setCurrentIndex(index);
        subscriptionsOnChangeCurrentIndex.forEach((callback)=>callback(index));
    }
    function onChangeCurrentIndex(callback) {
        subscriptionsOnChangeCurrentIndex.push(callback);
    }
    function getList() {
        return storage.getList();
    }
    function setList(list) {
        storage.setList(list);
    }
    function findIndex({ attendeeUid: attendeeUid, eventCode: eventCode }) {
        return getList().findIndex((account)=>account.attendeeUid === attendeeUid && account.eventCode === eventCode);
    }
    function findIndexByEventCode(eventCode) {
        return getList().findIndex((account)=>account.eventCode === eventCode);
    }
    function isExistsAccount({ attendeeUid: attendeeUid, eventCode: eventCode }) {
        return findIndex({
            attendeeUid: attendeeUid,
            eventCode: eventCode
        }) > -1;
    }
}

});


parcelRegister("39WRD", function(module, exports) {

$parcel$export(module.exports, "initEventOrganisationDataStorage", function () { return $24cfdf8cf119b922$export$e0729f1abb635550; });
function $24cfdf8cf119b922$export$e0729f1abb635550() {
    return {
        /**
     * Stores organisation domain data in localStorage.
     * If domain values exist, they are stored; if not, they are removed from localStorage.
     *
     * @param {Object} organisation - The organisation object containing domain information
     * @param {string} [organisation.photo_share_domain] - Photo share domain URL
     * @param {string} [organisation.webapp_domain] - Webapp domain URL
     */ storeEventOrganisationData (organisation) {
            if (!organisation || typeof organisation !== "object") return;
            const domainFields = [
                {
                    key: "photo_share_domain",
                    value: organisation.photo_share_domain
                },
                {
                    key: "webapp_domain",
                    value: organisation.webapp_domain
                }
            ];
            domainFields.forEach(({ key: key, value: value })=>{
                if (value && typeof value === "string" && value.trim()) localStorage.setItem(key, value.trim());
                else localStorage.removeItem(key);
            });
        },
        getPhotoShareDomainFromStorage () {
            return localStorage.getItem("photo_share_domain");
        },
        getWebappDomainFromStorage () {
            return localStorage.getItem("webapp_domain");
        },
        hasPhotoShareDomain () {
            return Boolean(localStorage.getItem("photo_share_domain"));
        },
        hasWebappDomain () {
            return Boolean(localStorage.getItem("webapp_domain"));
        }
    };
}

});


var $4GXSU = parcelRequire("4GXSU");

var $iD6my = parcelRequire("iD6my");

var $iEDEb = parcelRequire("iEDEb");

var $b7OGL = parcelRequire("b7OGL");

var $htyRP = parcelRequire("htyRP");

var $9lxLe = parcelRequire("9lxLe");

var $jGoKE = parcelRequire("jGoKE");

var $2oIdW = parcelRequire("2oIdW");

var $4ZXvf = parcelRequire("4ZXvf");

var $6bOHy = parcelRequire("6bOHy");

var $39WRD = parcelRequire("39WRD");
const $f824a3c1b91cb4dc$var$eventOrganisationDataStorage = (0, $39WRD.initEventOrganisationDataStorage)();
const { isSetUpEventName: $f824a3c1b91cb4dc$var$isSetUpEventName } = (0, $b7OGL.validationVariants);
const $f824a3c1b91cb4dc$var$form = (0, $iEDEb.initRegForm)();
async function $f824a3c1b91cb4dc$var$init() {
    var _event_organisation;
    (0, $iEDEb.prepareRegPage)();
    (0, $b7OGL.assertPageParams)([
        $f824a3c1b91cb4dc$var$isSetUpEventName
    ]);
    (0, $iEDEb.initPrivacyPolicyLink)();
    const event = await (0, $b7OGL.fetchData).event();
    if (!event) $4GXSU.withScope((scope)=>{
        scope.setTag("module", "registration");
        scope.setLevel("error");
        scope.setContext("localStorage", {
            eventName: localStorage.getItem("eventName")
        });
        $4GXSU.captureException(new Error("Event name is missing in localStorage"));
    });
    const { opts: opts } = event;
    (0, $6bOHy.saveLocParams)({
        orgId: (_event_organisation = event.organisation) === null || _event_organisation === void 0 ? void 0 : _event_organisation.id,
        eventCode: event.name
    });
    await (0, $6bOHy.initLoc)();
    if (event.organisation) $f824a3c1b91cb4dc$var$eventOrganisationDataStorage.storeEventOrganisationData(event.organisation);
    (0, $6bOHy.setTextToElement)("#createAtt", (0, $6bOHy.t)("submit-registration-btn"));
    (0, $htyRP.setLogo)(opts.webappCustomLogoSrc);
    (0, $htyRP.setBackground)(opts.webappCustomBackgroundSrc);
    if (opts.webappIsEnabledSMS) $f824a3c1b91cb4dc$var$form.enablePhoneNumber(opts.webappSMSAgreement);
    if ((0, $iEDEb.isNeedToShowPrivacy)(opts)) $f824a3c1b91cb4dc$var$form.enableAgreePrivacy();
    $f824a3c1b91cb4dc$var$form.onSubmit(async ({ name: name, email: email, phoneNumber: phoneNumber })=>{
        const { result: attendeeUid } = await (0, $iD6my.createAttendee)({
            eventCode: event.name,
            name: name,
            email: email,
            phoneNumber: phoneNumber
        });
        if (!attendeeUid) {
            alert((0, $iEDEb.getErrorRegFallBecauseOfAttendeeNull)({
                canBeEmailConfirmationProblem: true
            }));
            return;
        }
        const { result: attendee } = await (0, $2oIdW.findAttendeeByUIDAndEventId)(attendeeUid, event.id);
        (0, $jGoKE.default).addAccount({
            attendeeUid: attendeeUid,
            eventCode: event.name,
            eventLogo: opts.webappCustomLogoSrc,
            name: name,
            email: email,
            phoneNumber: phoneNumber,
            regDate: attendee.created_date,
            expireDate: (0, $4ZXvf.calculateExpiredDate)(event, attendee)
        });
        (0, $jGoKE.default).setCurrentAccount(0);
        (0, $9lxLe.redirectToPage).index({
            rawSearch: window.location.search
        });
    });
}
document.addEventListener("DOMContentLoaded", $f824a3c1b91cb4dc$var$init);

})();
//# sourceMappingURL=reg-user.49aed407.js.map
